module.exports = "<router-outlet></router-outlet>\n<cre-loading></cre-loading>\n"